import React from 'react';
import Node, {
  NodeProps,
} from 'components/canvas/components/nodes/components/base-node';
import { Text } from 'react-konva';
import NodeHeader from 'components/canvas/components/nodes/components/base-node/components/node-header';
import NodeContextMenu from 'components/canvas/components/nodes/components/base-node/components/node-context-menu';
import GlobalLinksIndicator from 'components/canvas/components/nodes/components/base-node/components/global-links-indicator';
import useNodeDimensionsOperations from 'components/canvas/hooks/use-node-dimensions-operations';
import { color, typography } from 'styles/settings';

interface TextNodeProps extends NodeProps {}

function TextNode(props: TextNodeProps) {
  const { node } = props;

  const { getNodeDimensionsByType } = useNodeDimensionsOperations();
  let isLink = true;

  const { width, height } = getNodeDimensionsByType(
    isLink ? 'link' : node.type,
  );

  //@ts-ignore
  const text = node?.text;

  return (
    <Node
      {...props}
      width={width}
      height={height}
      style={{ fill: color.neutral.grayLightest }}>
      {({ Rect }) => {
        return (
          <>
            <GlobalLinksIndicator node={node} x={width} />
            {Rect}

            <NodeHeader
              x={0}
              offsetY={40}
              fill="#1C1B18"
              fontStyle="bold"
              text={node.name ?? ''}
              width={width - 30}
              isReference={node.isReference}
            />

            <NodeContextMenu width={width} height={height} node={node} />

            <Text
              x={5}
              y={10}
              fill="#1C1B18"
              text={text}
              fontFamily={typography.font.fontFamily}
              fontWeight={400}
              lineHeight={1.5}
              width={width - 75}
              height={height - 5}
              fontSize={14}
            />
          </>
        );
      }}
    </Node>
  );
}

export default TextNode;
